import * as React from "react";
import { SharedDocumentsComponent } from './SharedDocumentsComponent';

export const Mozambique = () => {
    return <SharedDocumentsComponent permissionId="43" path="Moçambique e Malawi" />
}